import { BrokerMedia } from '@insurance/api/requests'
import { DownloadButton } from '@insurance/components'
import { ConditionalText, DateTimeCell, TableActions } from '@shared/components'
import { getFullName } from '@shared/utils'
import { Tooltip, Typography } from 'antd'
import { ColumnProps } from 'antd/es/table'
import { MenuProps } from 'antd/lib'
import { TFunction } from 'i18next'

export const getTableColumns = (
  actions: (content: BrokerMedia) => MenuProps['items'],
  t: TFunction
): ColumnProps<BrokerMedia>[] => [
  {
    title: t('file_name'),
    key: 'media_name',
    dataIndex: ['media', 'name'],
    render: (name) => (
      <ConditionalText condition={!!name}>{name}</ConditionalText>
    )
  },
  {
    title: t('notes'),
    key: 'notes',
    dataIndex: 'notes',
    width: 220,
    render: (notes) => (
      <ConditionalText condition={!!notes}>
        <Tooltip title={notes}>
          <Typography.Text ellipsis style={{ maxWidth: 200, display: 'block' }}>
            {notes}
          </Typography.Text>
        </Tooltip>
      </ConditionalText>
    )
  },
  {
    title: t('upload_date'),
    key: 'created',
    dataIndex: 'created',
    sorter: true,
    render: (created) => <DateTimeCell date={created} hiddenTime />
  },
  {
    title: t('uploaded_by'),
    key: 'author',
    dataIndex: 'author',
    render: (_, { author }) => (
      <ConditionalText condition={!!author}>
        {getFullName(author)}
      </ConditionalText>
    )
  },
  {
    title: t('download'),
    key: 'download',
    dataIndex: 'media',
    render: (media) => <DownloadButton file={media?.id} />
  },
  {
    key: 'actions',
    align: 'center',
    width: 80,
    render: (_, row) => <TableActions options={actions(row)} />
  }
]
